import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 33 27"
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.025",
  d: "M30.24 18.837c0 2.024-1.833 3.663-4.096 3.663H9.496c-2.263 0-4.096-1.64-4.096-3.663v-7.66l.001-3.013C5.401 6.14 7.236 4.5 9.497 4.5h16.646c2.261 0 4.096 1.64 4.096 3.664l.001 2.918z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.025",
  d: "M22.904 25.875H6.256c-2.263 0-4.096-1.672-4.096-3.737v-7.814l.001-3.074M8.19 7.334h-.116m19.556 0h-.116m.116 12.375h-.116m-19.324 0h-.116"
}, null, -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("ellipse", {
  cx: "18.36",
  cy: "13.5",
  stroke: "currentColor",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  "stroke-width": "2.025",
  rx: "3.24",
  ry: "3.375"
}, null, -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [..._hoisted_5]))
}
export default { render: render }